import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, reset, change } from "redux-form";
import { isMobile } from "Constants";
import LocaleStrings from "Languages";
import { Modal, Col, Row, Grid } from "react-bootstrap";
import _ from "lodash";
import {
  openCloneOptions,
  cloneEventAction,
  fetchAllRelatedEvents,
} from "Actions";
import {
  COMMON_FAIL_MESSAGE,
  chooserPopupHeight,
  chooserPopupGridHeight,
} from "Constants";
import Button from "react-bootstrap-button-loader";
import {
  BaseComponent,
  LABEL_POSITION_TOP,
  required,
  noSpecialChar,
  email,
  number,
  alphaNumeric,
  phoneNumber,
  maxLength,
  minLength,
  minValue,
  maxValue,
  trim,
} from "BaseComponent";
import { bindActionCreators } from "redux";
import { showError, showSuccess } from "ReduxErrorBar";

class EventClone extends BaseComponent {
  constructor(props) {
    super(props);
    //const cookies = new Cookies();

    this.state = {
      loading: false,
      selectAllCheck: false,
    };
  }

  close() {
    // this.props.openCloneOptions({ showModal: false });
    this.props.actions.openCloneOptions({ showModal: false });
  }

  onSubmitForm = (values) => {
    this.setState({ loading: true });

    this.props.actions.cloneEventAction(this.props.session, values, (res) => {
      if (res.result.success) {
        setTimeout(() => {
          this.props.actions.fetchAllRelatedEvents(
            this.props.user,
            this.props.session
          );
        }, 300);
        this.setState({ loading: false });

        // console.log("SUCCESSFULLY CLONED.");
        this.props.actions.showSuccess(
          "This event has been Cloned successfully."
        );
        this.close();
      } else {
        this.setState({ loading: false });
        // console.log("ERROR IN CLONING.");
        this.props.actions.showError(COMMON_FAIL_MESSAGE);
        this.close();
      }
    });
  };

  handlePartialUpdate = (field, value) => {
    this.props.updateField("CloneForm", field, value);
  };

  selectAll = () => {
    // this.handlePartialUpdate('general', !this.state.selectAllCheck);
    // this.handlePartialUpdate('features', !this.state.selectAllCheck);
    this.handlePartialUpdate("branding", !this.state.selectAllCheck);
    this.handlePartialUpdate("schedules", !this.state.selectAllCheck);
    this.handlePartialUpdate("sponsors", !this.state.selectAllCheck);
    this.handlePartialUpdate("speakers", !this.state.selectAllCheck);
    this.handlePartialUpdate("messages", !this.state.selectAllCheck);
    this.handlePartialUpdate("exhibitors", !this.state.selectAllCheck);
    this.handlePartialUpdate("social", !this.state.selectAllCheck);
    this.handlePartialUpdate("maps", !this.state.selectAllCheck);
    this.handlePartialUpdate("gallery", !this.state.selectAllCheck);
    this.handlePartialUpdate("news", !this.state.selectAllCheck);
    this.handlePartialUpdate("about", !this.state.selectAllCheck);
    this.handlePartialUpdate("webview", !this.state.selectAllCheck);
    this.handlePartialUpdate("users", !this.state.selectAllCheck);
    this.handlePartialUpdate("pollsqa", !this.state.selectAllCheck);
    this.handlePartialUpdate("analytics", !this.state.selectAllCheck);

    this.setState({ selectAllCheck: !this.state.selectAllCheck });
  };

  deselectAll = (e) => {
    this.setState({ selectAllCheck: false });
  };

  renderFieldCheckbox(field) {
    var divClassName = `form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;

    return (
      <div className={divClassName}>
        <label
          className="custom-container-checkbox"
          style={{ marginBottom: 5, color: "#767988", fontWeight: "bold" }}>
          {field.label}

          <input type={field.type} {...field.input} disabled={field.disabled} />

          <span className="checkmark" />
        </label>
      </div>
    );
  }

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      editMode,
      initialValues,
      actionAppModules,
      selectedFeatures,
    } = this.props;

    // for selectedFeatures
    let schedule = _.filter(selectedFeatures, ["bsClass", "schedule"]);
    schedule = schedule[0];

    let speaker = _.filter(selectedFeatures, ["bsClass", "speaker"]);
    speaker = speaker[0];

    let exhibitor = _.filter(selectedFeatures, ["bsClass", "exhibitor"]);
    exhibitor = exhibitor[0];

    let sponsor = _.filter(selectedFeatures, ["bsClass", "sponsor"]);
    sponsor = sponsor[0];

    let message = _.filter(selectedFeatures, ["bsClass", "message"]);
    message = message[0];

    let maps = _.filter(selectedFeatures, ["bsClass", "maps"]);
    maps = maps[0];

    let news = _.filter(selectedFeatures, ["bsClass", "news"]);
    news = news[0];

    let social = _.filter(selectedFeatures, ["bsClass", "social"]);
    social = social[0];

    let about = _.filter(selectedFeatures, ["bsClass", "about"]);
    about = about[0];

    let webview = _.filter(selectedFeatures, ["bsClass", "webview"]);
    webview = webview[0];

    let gallery = _.filter(selectedFeatures, ["bsClass", "gallery"]);
    gallery = gallery[0];

    // for actionAppModules
    let website = _.filter(actionAppModules, ["bsClass", "website"]);
    website = website[0];

    let tickets = _.filter(actionAppModules, ["bsClass", "tickets"]);
    tickets = tickets[0];

    let users = _.filter(actionAppModules, ["bsClass", "users"]);
    users = users[0];

    let polls = _.filter(actionAppModules, ["bsClass", "polls"]);
    polls = polls[0];

    let outreach = _.filter(actionAppModules, ["bsClass", "outreach"]);
    outreach = outreach[0];

    let analytics = _.filter(actionAppModules, ["bsClass", "analytics"]);
    analytics = analytics[0];

    let community = _.filter(actionAppModules, ["bsClass", "community"]);
    community = community[0];

    let proposal = _.filter(actionAppModules, ["bsClass", "proposal"]);
    proposal = proposal[0];

    return (
      <div>
        <Modal
          className="modal-container"
          show={this.props.showEventCloneModal === true ? true : false}
          onHide={this.close}
          animation={true}
          keyboard={false}
          backdrop="static"
          dialogClassName="modal-md">
          <Modal.Header>
            <div className="import-modal-title">
              {LocaleStrings.clone_event_title_clone_this_event}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.close()}>
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <Modal.Body>
            <div style={{}}>
              <form onSubmit={handleSubmit(this.onSubmitForm)}>
                <div className="row">
                  <div className="col-md-12">
                    <div className="col-md-12">
                      <label
                        className="setting-company-section-heading mt-0"
                        style={{ color: "#767988" }}>
                        {" "}
                        Choose which data you want to copy
                      </label>
                      {/* <hr></hr> */}
                    </div>

                    <div
                      className="col-md-12"
                      style={{
                        border: "solid 1px #A9ABB5",
                        borderRadius: 10,
                        padding: 15,
                      }}>
                      {/* this extra col-md-12 div is given for an UI issue of checkbox */}
                      {/* <div className="col-md-12" style={{ marginTop: 15 }}>
                                                <Field
                                                    name="all"
                                                    label="Select All"
                                                    component={this.renderFieldCheckbox}
                                                    type="checkbox"
                                                    // onSelectAll={(e) => this.selectAll(e)}
                                                />
                                            </div> */}

                      <div className="col-md-12" style={{ marginTop: 15 }}>
                        <label
                          className="custom-container-checkbox"
                          style={{
                            marginBottom: 5,
                            color: "#767988",
                            fontWeight: "bold",
                          }}>
                          {"Select All"}

                          <input
                            type="checkbox"
                            onChange={this.selectAll}
                            checked={this.state.selectAllCheck}
                          />
                          <span className="checkmark" />
                        </label>
                      </div>

                      {/* <div className="col-md-12" style={{ marginTop: 15 }}>
                                                <Field
                                                    name="general"
                                                    label="General"
                                                    component={this.renderFieldCheckbox}
                                                    type="checkbox"
                                                    // disabled={this.state.selectAllCheck}
                                                    onChange={this.deselectAll}
                                                />
                                            </div> */}
                      {/* <div className="col-md-12" style={{ marginTop: 15 }}>
                                                <Field
                                                    name="features"
                                                    label="Features"
                                                    component={this.renderFieldCheckbox}
                                                    type="checkbox"
                                                    onChange={this.deselectAll}

                                                />
                                            </div> */}
                      <div className="col-md-12" style={{ marginTop: 15 }}>
                        <Field
                          name="branding"
                          label="Branding"
                          component={this.renderFieldCheckbox}
                          type="checkbox"
                          onChange={this.deselectAll}
                        />
                      </div>

                      {schedule && schedule.isenabled ? (
                        <div className="col-md-12" style={{ marginTop: 15 }}>
                          <Field
                            name="schedules"
                            label="Content / Schedules"
                            component={this.renderFieldCheckbox}
                            type="checkbox"
                            onChange={this.deselectAll}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      {sponsor && sponsor.isenabled ? (
                        <div className="col-md-12" style={{ marginTop: 15 }}>
                          <Field
                            name="sponsors"
                            label="Content / Sponsors"
                            component={this.renderFieldCheckbox}
                            type="checkbox"
                            onChange={this.deselectAll}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      {speaker && speaker.isenabled ? (
                        <div className="col-md-12" style={{ marginTop: 15 }}>
                          <Field
                            name="speakers"
                            label="Content / Speakers"
                            component={this.renderFieldCheckbox}
                            type="checkbox"
                            onChange={this.deselectAll}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      {message && message.isenabled ? (
                        <div className="col-md-12" style={{ marginTop: 15 }}>
                          <Field
                            name="messages"
                            label="Content / Messages"
                            component={this.renderFieldCheckbox}
                            type="checkbox"
                            onChange={this.deselectAll}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      {exhibitor && exhibitor.isenabled ? (
                        <div className="col-md-12" style={{ marginTop: 15 }}>
                          <Field
                            name="exhibitors"
                            label="Content / Exhibitors"
                            component={this.renderFieldCheckbox}
                            type="checkbox"
                            onChange={this.deselectAll}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      {social && social.isenabled ? (
                        <div className="col-md-12" style={{ marginTop: 15 }}>
                          <Field
                            name="social"
                            label="Content / Social"
                            component={this.renderFieldCheckbox}
                            type="checkbox"
                            onChange={this.deselectAll}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      {maps && maps.isenabled ? (
                        <div className="col-md-12" style={{ marginTop: 15 }}>
                          <Field
                            name="maps"
                            label="Content / Maps (Location maps)"
                            component={this.renderFieldCheckbox}
                            type="checkbox"
                            onChange={this.deselectAll}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      {gallery && gallery.isenabled ? (
                        <div className="col-md-12" style={{ marginTop: 15 }}>
                          <Field
                            name="gallery"
                            label="Content / Gallery"
                            component={this.renderFieldCheckbox}
                            type="checkbox"
                            onChange={this.deselectAll}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      {news && news.isenabled ? (
                        <div className="col-md-12" style={{ marginTop: 15 }}>
                          <Field
                            name="news"
                            label="Content / News"
                            component={this.renderFieldCheckbox}
                            type="checkbox"
                            onChange={this.deselectAll}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      {about && about.isenabled ? (
                        <div className="col-md-12" style={{ marginTop: 15 }}>
                          <Field
                            name="about"
                            label="Content / About"
                            component={this.renderFieldCheckbox}
                            type="checkbox"
                            onChange={this.deselectAll}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      {webview && webview.isenabled ? (
                        <div className="col-md-12" style={{ marginTop: 15 }}>
                          <Field
                            name="webview"
                            label="Content / Webview"
                            component={this.renderFieldCheckbox}
                            type="checkbox"
                            onChange={this.deselectAll}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      {users && users.isenabled ? (
                        <div className="col-md-12" style={{ marginTop: 15 }}>
                          <Field
                            name="users"
                            label="Users"
                            component={this.renderFieldCheckbox}
                            type="checkbox"
                            onChange={this.deselectAll}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      {polls && polls.isenabled ? (
                        <div className="col-md-12" style={{ marginTop: 15 }}>
                          <Field
                            name="pollsqa"
                            label="Polls"
                            component={this.renderFieldCheckbox}
                            type="checkbox"
                            onChange={this.deselectAll}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      {analytics && analytics.isenabled ? (
                        <div className="col-md-12" style={{ marginTop: 15 }}>
                          <Field
                            name="analytics"
                            label="Analytics"
                            component={this.renderFieldCheckbox}
                            type="checkbox"
                            onChange={this.deselectAll}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      <div className="col-md-12 text-center">
                        <Button
                          className="btn-custom-blue mt-70 mb-10"
                          loading={this.state.loading}
                          disabled={pristine || invalid || submitting}
                          type="submit">
                          Clone
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-custom-white"
              onClick={(e) => this.close()}>
              Close
            </Button>
            {/* <Button className="btn btn-custom-blue ml-10"  type="button" loading={false} onClick={this.submitFormOn} disabled={false}>Clone</Button> */}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

function validate(values) {
  var errors = {};

  return errors;
}

function mapStateToProps(state) {
  return {
    session: state.session,
    user: state.user,
    initiateEventCreation: state.initiateCreateEvent,
    showEventCloneModal: state.showEventCloneModal,
    actionAppModules: state.actionAppModules,
    selectedFeatures: state.selectedFeatures,
  };
}

var mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      openCloneOptions,
      cloneEventAction,
      showError,
      showSuccess,
      fetchAllRelatedEvents,
    },
    dispatch
  ),
  updateField: (form, field, newValue) =>
    dispatch(change(form, field, newValue)),
});

// export default connect(mapStateToProps, { openCloneOptions })(reduxForm({
//     validate,
//     form: 'CloneForm',
//     enableReinitialize: true,
//     // keepDirtyOnReinitialize: true
// })(EventClone));

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    validate,
    form: "CloneForm",
    enableReinitialize: true,
    // keepDirtyOnReinitialize: true
  })(EventClone)
);
